/* */ 
exports.f = Object.getOwnPropertySymbols;
